












































import {Component, Vue} from 'vue-property-decorator';
import PhoneSelect from '@/components/ui/PhoneSelect.vue';
import ContentSection from '@/components/ContentSection.vue';
import {IContentSection} from '@/components/types';

@Component({
	components: {
		'v-content-section': ContentSection,
		'v-phone-select': PhoneSelect
	}
})
export default class SendApp extends Vue {

	isSend: Boolean = false;

	get absolutePath() {
		return serverVariables.httpRequest.baseUrl;
	}

	get getPdfPath() {
		return this.absolutePath + 'dist/pdf/';
	}

	get content(): IContentSection[] {
		return [
			{
				headline: this.$t('download.headline') as string,
				perex: this.$t('download.perex') as string
			},
			{
				headline: this.$t('success.headline') as string,
				perex: this.$t('success.perex') as string
			}
		]
	}
}
